import { BackendFactory } from 'dnd-core';

import detectIt from 'detect-it';
import TouchBackend from 'react-dnd-touch-backend';
import HTML5Backend from 'react-dnd-html5-backend';

const isTouchDevice = detectIt.hasTouch;

/**
 * This hook sets up the drag&drop backend for a re-orderable list.
 * It will create a touch specific backend on mobile with options that will
 * still allow vertical scrolling.
 */
const useReorderDragDropBackend = (): [BackendFactory, any, boolean] => {
  const DragDropBackend = isTouchDevice ? TouchBackend : HTML5Backend;

  const backendOptions = isTouchDevice
    ? {
        /** For cases where there is touch support but also mouse support we can fallback to the TouchBackend with mouse events. */
        enableMouseEvents: true,
      }
    : undefined;

  return [DragDropBackend, backendOptions, isTouchDevice];
};

export default useReorderDragDropBackend;
